// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3qh5t","alert":"SettungsInbox_alert__12b35"};